import React, { useState, useEffect } from "react";
import db from "../../../db/index.json";
import SearchBar from "../../reusebale/searchBar";
import LeasesTable from "./leaseTable";
import FilterPopup from "../../popup/filterPopup";
import BaseUrl from "../../../constants/BaseUrl";
import DetailMain from "./leaseDetail/main";
import { useSelector } from "react-redux"

const LeasesSection = ({ onTriggerCard, onMaintainanceTable, handleTenantTable, handleMaintainDetail }) => {
  const { lease } = db;
  const { loginSuccess } = useSelector(
    (state) => state.auth
  );
  const [showFilter, setShowFilter] = useState(false);
  const [showTable, setShowTable] = useState("table");
  const [showDetail, setShowDetail] = useState("");
  const [recordId, setRecordId] = useState();

  const [search, setSearch] = useState("")


  const [leasesData, setAllLeasesData] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalLeases, setTotalLeases] = useState(0);
  const itemsPerPage = 10;


  const GetAllLease = (page = 1) => {
    setLoading(true)
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(`${BaseUrl}api/lease/getAllLeaseByTenant/${loginSuccess.user._id}?page=${page}&limit=${itemsPerPage}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setLoading(false)
          setAllLeasesData(result.data)
          if (result.pagination) {
            setTotalPages(result.pagination.totalPages);
            setTotalLeases(result.pagination.totalLeases);
            setCurrentPage(result.pagination.currentPage);
          }
        } else {
          setLoading(false)
        }
      })
      .catch((error) => console.error(error));
  }


  useEffect(() => {
    GetAllLease(currentPage)
  }, [currentPage])

  const openPopup = () => {
    setShowFilter(true);
  };

  const closePopup = () => {
    setShowFilter(false);
  };

  const toggleDetail = (status, id) => {
    setShowDetail(status);
    setRecordId(id);
    setShowTable("detail"); // State toggle karein

  };

  const toggleCreate = () => {
    setShowTable("create"); // State toggle karein
  };

  const toggleTable = () => {
    setShowTable("table"); // State toggle karein
  };



  return (
    <div>
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div>
                <div className="h-[10vh] pr-2">
                  <SearchBar
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                    title={lease.title}
                    desc={lease.desc}

                  />
                  {/* <SearchBar
                    title={lease.title}
                    desc={lease.description}
                    onSubmit={openPopup}
                  /> */}
                </div>

                <div className="h-[90vh]">
                  <LeasesTable
                    search={search}
                    isViewDetails={toggleDetail}
                    onViewCreate={toggleCreate}
                    leasesData={leasesData}
                    loading={loading}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalLeases={totalLeases}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
              </div>
            );
          case "detail":
            return <DetailMain onBack={toggleTable} showDetailStatus={showDetail} recordId={recordId} onTriggerCard={onTriggerCard} onMaintainancePage={onMaintainanceTable} toggleTennatTable={handleTenantTable} onViewDetailsMaintain={handleMaintainDetail}/>;
          // case "create":
          //   return <CreateMain onBack={toggleTable} />;
          default:
            break;
        }
      })()}
      {showFilter && <FilterPopup onBack={closePopup} onFilter={closePopup} />}
    </div>
  );
};

export default LeasesSection;
